/**
 * If params.skus === {{product.id}} then use
 * window._fwn.productData.product_ext_id.
 * Otherwise, use params.skus.
 * This is supported from the BE with every integration,
 * so we can safely use it.
 * @param skus
 * @returns
 */
export function updateSkus(skus) {
    if (!window?._fwn?.productData) {
        return skus;
    }
    const { product_ext_id } = window._fwn.productData;
    if (!product_ext_id) {
        return skus;
    }
    const productSku = skus === '{{product.id}}' ? product_ext_id : skus;
    return productSku;
}
